import en from './translations/en.json';
import AiSearch from '@commutifi-fe/commutifi-specific/locales/translations/aiSearch.en.json';
export default {
  ...en,
  ...AiSearch
};